import tiresList from './List'
import tiresShow from './Show'
import tiresEdit from './Edit'

const tiresResource = {
  list: tiresList,
  show: tiresShow,
  edit: tiresEdit,
}

export default tiresResource
